import React from 'react'
import { observer } from 'mobx-react'
import useSelection from '../hooks/use-selection'
import useModelKey from '../hooks/use-model-key'

function SelectOnClick (props) {
  const selection = useSelection()
  const modelKey = useModelKey()

  const handleClick = () => {
    if (!modelKey) {
      return
    }

    selection.add(modelKey)
  }

  return (
    <div onClick={handleClick}>
      {props.children}
    </div>
  )
}

export default observer(SelectOnClick)
